import { cn } from '@/lib/utils'

interface Props {
  name: string
  detail?: string
  onClick?: () => void
  className?: string
}

export function ChainBadge({ name, detail, onClick, className }: Props) {
  const text = detail ? `${name} · ${detail}` : name
  const segments = (
    <>
      <span className="flex items-center bg-background px-2 py-0.5 text-foreground">Chain</span>
      <span className="flex items-center bg-purple-foreground px-2 py-0.5 text-background">{text}</span>
    </>
  )

  const shell = 'inline-flex shrink-0 items-stretch overflow-hidden rounded-md border text-xs font-medium'

  if (onClick) {
    return (
      <button
        type="button"
        aria-label={`Open chain run ${name}`}
        onClick={onClick}
        className={cn(shell, 'cursor-pointer hover:opacity-80', className)}
        data-testid="chain-badge"
      >
        {segments}
      </button>
    )
  }

  return (
    <span className={cn(shell, className)} data-testid="chain-badge">
      {segments}
    </span>
  )
}
